import { render, staticRenderFns } from "./DynamicResource.vue?vue&type=template&id=0cbd2f0e&"
import script from "./DynamicResource.vue?vue&type=script&lang=js&"
export * from "./DynamicResource.vue?vue&type=script&lang=js&"
import style0 from "./DynamicResource.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports